import React from "react";
import AuthPageWrapper from "./AuthPageWrapper";
import Button from "../ui/Button";
import { useNavigate } from "react-router-dom";

const AuthSuccess = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/");
  };

  return (
    <AuthPageWrapper>
      <div className="flex flex-col gap-4 items-center">
        <img src="/assets/images/png/success.png" alt="" />
        <div className="flex flex-col w-[450px] items-center">
          <h2 className="text-26px font-bold mb-2">Email Verified</h2>
          <p className="text-sm text-center text-gray-500 mb-6">
            Your account has been activated. Click the button below to continue
            to your dashboard
          </p>
        </div>
        <Button label="Continue to Dashboard" type="submit" onClick={handleGetStarted} />
      </div>
    </AuthPageWrapper>
  );
};

export default AuthSuccess;
